import { formatDate } from "../../utilities/CommonUtilities";

export class FetchDashboardDataRequest {
  constructor(dashboardName, filterDate) {
    this.dashboard_name = dashboardName;
    this.frame_work = "";
    let startDate =
      filterDate.startDate === "" ? new Date() : filterDate.startDate;
    startDate.setDate(startDate.getDate());
    this.start_date = formatDate(startDate);
    let endDate = filterDate.endDate === "" ? new Date() : filterDate.endDate;
    endDate.setDate(endDate.getDate());
    this.end_date = formatDate(endDate);
    this.company_id = null;
    this.countries = null;
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}
